// Managers whose saved evaluation rubric comes from metadata/config.question.
// This is distinct from LlmJudgeMetricBase membership, which includes additional
// manager families and excludes audio judges. Shared by the editor and Sofia.
const QUESTION_REQUIRED_MANAGERS = new Set([
  "manager_agentic_llm_judge",
  "manager_agentic_llm_judge_categorical",
  "manager_agentic_llm_judge_numerical",
  "manager_llm_binary",
  "manager_default_categorical",
  "manager_numerical_llm_judge",
  "manager_audio_llm_judge",
  "manager_audio_llm_binary",
  "manager_audio_llm_categorical",
  "manager_audio_llm_numerical",
])

export function requiresMetricQuestion(manager: string | undefined): boolean {
  return manager !== undefined && QUESTION_REQUIRED_MANAGERS.has(manager)
}
